var render, staticRenderFns
import script from "./section-tabs.ts?vue&type=script&lang=ts&external"
export * from "./section-tabs.ts?vue&type=script&lang=ts&external"
import style0 from "./section-tabs.vue?vue&type=style&index=0&id=3978cdc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3978cdc6",
  null
  
)

export default component.exports